<script setup>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import { library } from "@fortawesome/fontawesome-svg-core";
import {
    faFacebook,
    faReddit,
    faTelegram,
    faWhatsapp,
    faXTwitter,
} from "@fortawesome/free-brands-svg-icons";

library.add(faXTwitter, faFacebook, faReddit, faTelegram, faWhatsapp);

defineProps({
    url: {
        type: String,
        required: true,
    },
});
function share(platform, url) {
    let shareUrl;
    switch (platform) {
        case "facebook":
            shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${url}`;
            break;
        case "telegram":
            shareUrl = `https://t.me/share/url?url=${url}`;
            break;
        case "whatsapp":
            shareUrl = `https://wa.me/?text=${url}`;
            break;
        case "reddit":
            shareUrl = `https://reddit.com/submit?url=${url}`;
            break;
        case "x":
            shareUrl = `https://x.com/intent/tweet?url=${url}`;
            break;
    }
    window.open(shareUrl, "_blank");
}
</script>

<template>
    <div class="mt-2.5 flex flex-col space-y-2">
        <span class="text-gray-600">Share this article:</span>
        <div class="space-x-4 flex">
            <button @click="share('facebook', url)">
                <font-awesome-icon
                    :icon="['fa-brands', 'fa-facebook']"
                    class="text-blue-500 text-2xl"
                />
            </button>
            <button @click="share('telegram', url)">
                <font-awesome-icon
                    :icon="['fa-brands', 'fa-telegram']"
                    class="text-[#229ED9] text-2xl"
                />
            </button>
            <button @click="share('whatsapp', url)">
                <font-awesome-icon
                    :icon="['fa-brands', 'fa-whatsapp']"
                    class="text-green-500 text-2xl"
                />
            </button>
            <button @click="share('reddit', url)">
                <font-awesome-icon
                    :icon="['fa-brands', 'fa-reddit']"
                    class="text-red-500 text-2xl"
                />
            </button>
            <button @click="share('x', url)">
                <font-awesome-icon
                    :icon="['fa-brands', 'fa-x-twitter']"
                    class="text-2xl"
                />
            </button>
        </div>
    </div>
</template>
